import React, { useContext, useEffect, useState, useMemo } from "react";
import { TextField, MenuItem, Button, Autocomplete, Box } from "@mui/material";
import { ContextData } from "../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../BaseURL";
import SoundAlert from "../../../../../routes/SoundAlert";
import { Getrequest } from "../../../../../context/AxiosRequest";

function Education({ formData }) {
  const { UserTokens, ReloadBioForms, setReloadBioForms, ChangeLoanForm } =
    useContext(ContextData);

  const [institutionList, setInstitutionList] = useState([]);
  const [selectedInstitution, setSelectedInstitution] = useState(null);
  const [isManualUni, setIsManualUni] = useState(false);

  const [formDatas, setFormDatas] = useState({
    matric_num: formData.education.matric_num || "",
    faculty: formData.education.faculty || "",
    deparment: formData.education.deparment || "",
    gpa: formData.education.gpa || "",
    university: formData.education.university || "",
    university_state: formData.education.university_state || "",
    current_level: formData.education.current_level || "",
    year_of_admission: formData.education.year_of_admission || "",
    year_of_graduation: formData.education.year_of_graduation || "",
    course_of_study: formData.education.course_of_study || "",
    nelfund_status: formData.education.nelfund_status || "",
    nelfund_indicator: formData.education.nelfund_indicator || "",
    manual_university: formData.education.manual_university || "",
    manual_university_state: formData.education.manual_university_state || "",
  });

  useEffect(() => {
    async function FetchInstitution() {
      const response = await Getrequest("/auth/get_uni/applicnt", UserTokens);
      setInstitutionList(response || []);
    }
    FetchInstitution();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDatas((prev) => ({ ...prev, [name]: value }));
  };

  const validateField = (field) => {
    if (field === "university") {
      if (isManualUni) {
        if (!formDatas.manual_university.trim() || !formDatas.manual_university_state.trim()) {
          SoundAlert("error");
          toast.error("Please enter both university name and state.");
          return false;
        }
        return true;
      } else {
        if (
          (!selectedInstitution || !selectedInstitution.university_name) &&
          (!formDatas.university || formDatas.university.trim() === "")
        ) {
          SoundAlert("error");
          toast.error("Please select or enter your university.");
          return false;
        }
        return true;
      }
    }

    if (!formDatas[field] || formDatas[field].toString().trim() === "") {
      SoundAlert("error");
      toast.error("Please fill in all required fields.");
      return false;
    }
    return true;
  };

  const handleSubmit = (field) => {
    if (!validateField(field)) return;

    const payload = { ...formDatas, user_token: UserTokens };

    if (field === "university") {
      if (isManualUni) {
        payload.university = formDatas.manual_university;
        payload.university_state = formDatas.manual_university_state;
      } else if (selectedInstitution && selectedInstitution.university_name) {
        payload.university = selectedInstitution.university_name;
        payload.university_state = selectedInstitution.state_of_location || "";
      } else {
        payload.university = formDatas.university;
        payload.university_state = formDatas.university_state || "";
      }
    }

    axios
      .put(`${baseUrl}/auth/edu_update`, payload, {
        withCredentials: true,
        headers: { Accept: "application/json" },
      })
      .then((res) => {
        if (res.data.status) {
          SoundAlert("success");
          toast.success(res.data.textStatus);
          setReloadBioForms(!ReloadBioForms);
          if (field === "university") {
            setFormDatas((prev) => ({
              ...prev,
              manual_university: "",
              manual_university_state: "",
            }));
            setIsManualUni(false);
          }
        }
      })
      .catch((err) => {
        toast.error(err.message);
        console.error(err);
      });
  };

  const autoOptions = useMemo(
    () => [
      ...institutionList,
      { id: "others", university_name: "Others", state_of_location: "" },
    ],
    [institutionList]
  );

  const autocompleteValue = useMemo(() => {
    if (selectedInstitution) return selectedInstitution;
    if (formDatas.university) return formDatas.university;
    return null;
  }, [selectedInstitution, formDatas.university]);

  return (
    <div className="pt-2 pb-2">
      {/* Matric Number */}
      <TextField
        label="Matric Number"
        name="matric_num"
        type="text"
        value={formDatas.matric_num}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("matric_num")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Institution */}
      <p className="pt-1 pb-1 font-extrabold">Institution/University</p>

      <Autocomplete
        freeSolo
        options={autoOptions}
        getOptionLabel={(option) => {
          if (typeof option === "string") return option;
          return option.university_name
            ? `${option.university_name}${option.state_of_location ? ` : ${option.state_of_location} State` : ""}`
            : "";
        }}
        filterOptions={(options, params) => {
          const filtered = options.filter((opt) => {
            return (opt.university_name || "").toLowerCase().includes(params.inputValue.toLowerCase()) ||
            (opt.state_of_location || "").toLowerCase().includes(params.inputValue.toLowerCase());
          });
          if (!filtered.some((o) => typeof o !== "string" && o.id === "others")) {
            filtered.push({ id: "others", university_name: "Others", state_of_location: "" });
          }
          return filtered;
        }}
        value={autocompleteValue}
        onChange={(event, newValue) => {
          if (!newValue) {
            setSelectedInstitution(null);
            setIsManualUni(false);
            return;
          }

          if (typeof newValue === "string") {
            setSelectedInstitution(null);
            setFormDatas((prev) => ({
              ...prev,
              university: newValue,
              university_state: "",
              manual_university: newValue,
              manual_university_state: "",
            }));
            setIsManualUni(true);
            return;
          }

          if (newValue.id === "others" || newValue.university_name === "Others") {
            setSelectedInstitution(null);
            setIsManualUni(true);
            setFormDatas((prev) => ({
              ...prev,
              manual_university: "",
              manual_university_state: "",
            }));
          } else {
            setSelectedInstitution(newValue);
            setIsManualUni(false);
            setFormDatas((prev) => ({
              ...prev,
              university: newValue.university_name,
              university_state: newValue.state_of_location || "",
              manual_university: "",
              manual_university_state: "",
            }));
          }
        }}
        onInputChange={(event, inputValue, reason) => {
          if (reason === "input") {
            setFormDatas((prev) => ({ ...prev, university: inputValue }));
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search or Select Institution"
            margin="dense"
            required
            fullWidth
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => handleSubmit("university")}
                    sx={{ mr: 1 }}
                  >
                    Save
                  </Button>
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />

      {/* Manual University Fields */}
      {isManualUni && (
        <Box sx={{ mt: 1 }}>
          <TextField
            label="Enter University Name"
            name="manual_university"
            value={formDatas.manual_university}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            InputProps={{
              endAdornment: (
                <Button variant="outlined" color="secondary" onClick={() => handleSubmit("university")}>
                  Save
                </Button>
              ),
            }}
          />
          <TextField
            label="State of Location"
            name="manual_university_state"
            value={formDatas.manual_university_state}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            sx={{ mt: 1 }}
            InputProps={{
              endAdornment: (
                <Button variant="outlined" color="secondary" onClick={() => handleSubmit("university")}>
                  Save
                </Button>
              ),
            }}
          />
        </Box>
      )}

      {/* State of Location */}
      {!isManualUni && (
        <TextField
          label="State of Location"
          name="university_state"
          value={formDatas.university_state}
          onChange={handleChange}
          fullWidth
          margin="dense"
          required
          helperText="Auto-filled from selected university. Edit if needed."
          InputProps={{
            endAdornment: (
              <Button variant="outlined" color="secondary" onClick={() => handleSubmit("university")}>
                Save
              </Button>
            ),
          }}
        />
      )}

      {/* Faculty */}
      <TextField
        label="Faculty"
        name="faculty"
        type="text"
        value={formDatas.faculty}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("faculty")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Department */}
      <TextField
        label="Department"
        name="deparment"
        type="text"
        value={formDatas.deparment}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("deparment")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Current Level */}
      <TextField
        label="Current Level"
        name="current_level"
        type="number"
        value={formDatas.current_level}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("current_level")}>
              Save
            </Button>
          ),
        }}
      />

      {/* GPA */}
      <TextField
        label="GPA"
        name="gpa"
        type="number"
        value={formDatas.gpa}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("gpa")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Year Of Admission */}
      <p className="pt-1 pb-1 font-extrabold">Year Of Admission</p>
      <TextField
        name="year_of_admission"
        type="date"
        value={formDatas.year_of_admission}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("year_of_admission")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Year Of Graduation */}
      <p className="pt-1 pb-1 font-extrabold">Year Of Graduation (mm/dd/yyyy)</p>
      <TextField
        name="year_of_graduation"
        type="date"
        value={formDatas.year_of_graduation}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("year_of_graduation")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Course Of Study */}
      <TextField
        label="Course Of Study"
        name="course_of_study"
        type="text"
        value={formDatas.course_of_study}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("course_of_study")}>
              Save
            </Button>
          ),
        }}
      />

      {/* NELFUND Section */}
      {ChangeLoanForm === "studentloan" && (
        <>
          <p className="pt-1 pb-1 font-extrabold">Have you applied for NELFUND Loan?</p>

          <TextField
            select
            label="Select Yes or No"
            name="nelfund_status"
            value={formDatas.nelfund_status}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            InputProps={{
              endAdornment: (
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => handleSubmit("nelfund_status")}
                >
                  Save
                </Button>
              ),
            }}
          >
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </TextField>

          <p className="pt-1 pb-1 font-extrabold">If YES, indicate your loan Status</p>

          <TextField
            label="Nelfund Indicator"
            name="nelfund_indicator"
            type="text"
            value={formDatas.nelfund_indicator}
            onChange={handleChange}
            fullWidth
            margin="dense"
            
            InputProps={{
              endAdornment: (
                <Button variant="outlined" color="secondary" onClick={() => handleSubmit("nelfund_indicator")}>
                  Save
                </Button>
              ),
            }}
          />
        </>
      )}
    </div>
  );
}

export default React.memo(Education);
